export default "__VITE_ASSET__C2PA5gIL__"